module.exports = __webpack_public_path__ + "summernote.eot";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.eot?ad8d7e2d177d2473aecd9b35d16211fb
// module id = 1150
// module chunks = 14